module.exports = __webpack_public_path__ + "static/trans-studio-ae4933d1914105b967f540008166fc18.jpg";